// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"51":"f87eeb4fd662bb0c3b6f","948":"f8db400cb9a047ad6d6d"}[chunkId] + ".js";
};